import { Grid, TextField } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class IInboundInvoiceApprovalListStyles extends CommonComponentStyle {
  GridWrapper = styled(Grid)`
    padding: 8px 0;
  `;

  TaskDocumentMainInfoWrapper = styled(Grid)`
    margin: 16px 0;
  `;

  DocumentNumberText = styled(Grid)`
    font-size: 16px;
    font-weight: 700;
  `;

  VendorText = styled(Grid)`
    font-size: 14px;
    color: ${this.colors.PRIMARY_GRAY};
  `;

  ContentWrapper = styled.div`
    padding: 16px 0;
    padding-bottom: 80px;
  `;

  StickyFooterWrapper = styled(this.FooterWrapper)`
    position: sticky;
    align-items: center;
    justify-content: center;
  `;

  SearchBar = styled(TextField)`
    width: 100%;
    margin-bottom: 8px !important;
  `;

  TaskItemWrapper = styled(Grid)`
    background-color: ${this.colors.LIGHTER_GRAY};
    padding-top: 8px;
    margin-top: 8px;
  `;

  TaskItemSkuCode = styled(Grid)`
    font-size: 14px;
    font-weight: 700;
  `;

  TaskItemDescription = styled(Grid)`
    font-size: 12px;
    font-weight: 700;
  `;

  TaskItemQTY = styled(Grid)`
    font-size: 12px;
    font-weight: 700;
    float: right;
  `;
}

export const IInboundInvoiceApprovalListStyle =
  new IInboundInvoiceApprovalListStyles();
